import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_BED_BANK } from 'constants/offer'

export default function hideAoLabel(offer: App.Offer | App.OfferSummary | App.BedbankOffer | App.BedbankOfferSummary): boolean {
  return offer.productType !== 'ultralux_hotel' && ((offer.type === OFFER_TYPE_ALWAYS_ON &&
  (!offer.tileInclusions || offer.tileInclusions.length < 1) &&
  (!offer.inclusions || offer.inclusions.length < 1)) ||
  offer.type !== OFFER_TYPE_BED_BANK && offer.isPartnerProperty)
}
